import React, { useState } from 'react'
import ClientSumariScreen from './ClientSomariVlScreen'
import { NavButton } from './style'
import ClientSumariCxScreen from './ClientSomariCxScreen'
import { FaBox, FaBoxOpen } from 'react-icons/fa'
import { PiCoinsFill } from 'react-icons/pi'
import { GiTwoCoins } from 'react-icons/gi'

export default function ClientMapScreen() {
  const [pages, setPages] = useState(0)

  return (
    <>
      <div
        style={{
          display: 'flex',
          gap: 10,
          width: '100%',
          justifyContent: 'center',
          marginBottom: 20,
        }}
      >
        <NavButton $active={pages === 0} type='button' onClick={() => setPages(0)}>
          {pages === 0 ? <GiTwoCoins /> : <PiCoinsFill />}
        </NavButton>
        <NavButton $active={pages === 1} type='button' onClick={() => setPages(1)}>
          {pages === 1 ? <FaBoxOpen /> : <FaBox />}
        </NavButton>
      </div>

      {pages === 0 ? <ClientSumariScreen /> : <ClientSumariCxScreen />}
    </>
  )
}
